import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Cam off SVG Icon for camera control button.
 */
export const CamOff: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 35 35"
    aria-hidden={true}
    {...props}
  >
    <path
      d="M32.1806 9.625L25.9583 15.8472V10.4028C25.9583 9.54722 25.2583 8.84722 24.4028 8.84722H14.7894L32.1806 26.2383V9.625ZM4.60056 2.625L2.625 4.60056L6.87167 8.84722H5.73611C4.88056 8.84722 4.18056 9.54722 4.18056 10.4028V25.9583C4.18056 26.8139 4.88056 27.5139 5.73611 27.5139H24.4028C24.7294 27.5139 25.0094 27.3894 25.2428 27.2339L30.205 32.1806L32.1806 30.205L4.60056 2.625Z"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
